import React from 'react';
import PopUp from '../../../muiComponents/PopUp';

const DeletePopUp = props => {
    return (
        <PopUp
            titleText={'delete_sure'}
            {...props}
            saveText='delete'
            saveButonProps={{ className: 'delete-button' }}
        />
    );
};

export default DeletePopUp;
